const SitePlanVisibleType={BIRDS_EYE_VIEW:'birdsEyeView', OUTSIDE_360:'outside360',
 CONFIGURATOR:'configurator', THREE_D:'threeD', LOCAL_AREA:'localArea',
 SPECIFICATION:'specification'};
SitePlanVisibleType.getCssClassName = function(val){
	switch(val){
		case SitePlanVisibleType.BIRDS_EYE_VIEW:
			return 'birds-eye-view-visible';
		case SitePlanVisibleType.OUTSIDE_360:
			return 'outside-360-visible';
		case SitePlanVisibleType.CONFIGURATOR:
			return 'configurator-visible';
		case SitePlanVisibleType.THREE_D:
			return 'three-d-visible';
		case SitePlanVisibleType.LOCAL_AREA:
			return 'local-area-visible';
		case SitePlanVisibleType.SPECIFICATION:
			return 'specification-visible';
	}
	return '';
}
export default SitePlanVisibleType;